/**
 * @method validateDate
 * @return {boolean} true if valid date D/M
 */
export var validateDate = function validateDate(target) {
  var matches = /^(0[1-9]|1[0-9]|2[0-9]|3[0-1]|[1-9])[/](0[1-9]|1[0-2]|[1-9])$/.exec(target);
  if (matches === null) {
    return false;
  }
  var d = parseInt(matches[1]);
  var m = matches[2] - 1;
  var dateObject = new Date(2019, m, d);
  return dateObject.getDate() === d && dateObject.getMonth() === m;
};

/**
 * @method validateTime
 * @return {Bool} true if valid time HH:mm
 */
export var validateTime = function validateTime(target) {
  var regex = /^(0[0-9]|1[0-9]|2[0-3]|[0-9]):[0-5][0-9]$/;
  return regex.test(target);
};